import { Flex } from "@instructure/ui";
import { memo, useEffect, useState } from "react";
import RichTextEditor from "react-rte";
import "./rte.css";

export const EMPTY_RTE = "<p><br></p>";

const CustomRTE = memo(
  ({
    id,
    label,
    defaultValue = "",
    value,
    onChange,
    readOnly,
    clear,
    setClear,
  }) => {
    const [textValue, setTextValue] = useState(
      RichTextEditor.createValueFromString(defaultValue, "html")
    );

    useEffect(() => {
      if (clear) {
        setTextValue(RichTextEditor.createValueFromString(EMPTY_RTE, "html"));
        setClear(false);
      }
    }, [clear, setClear]);

    return (
      <Flex wrap="wrap">
        <Flex.Item size="100%">
          <label
            htmlFor={id ?? "RTE"}
            style={{ marginBottom: label ? 10 : 0, display: "block" }}
          >
            {label}
          </label>
        </Flex.Item>
        <Flex.Item size="100%">
          <RichTextEditor
            className={`fontClass ${readOnly ? "readOnlyClass" : ""}`}
            id={id ?? "RTE"}
            value={
              value !== undefined && value !== null
                ? RichTextEditor.createValueFromString(value, "html")
                : textValue
            }
            onChange={(value) => setTextValue(value)}
            readOnly={readOnly}
            onBlur={() => {
              if (onChange) {
                onChange(textValue.toString("html"));
              }
            }}
          />
        </Flex.Item>
      </Flex>
    );
  }
);

export default CustomRTE;
